import {store} from "helper/store";
import introJs from "intro.js";
import 'intro.js/introjs.css';
import {startWebsiteTourForScan, stopWebsiteTour, stopWebsiteTourForScan} from "redux_actions/websitetour.action";
import {getStateAwareUrl} from "../utils/utils";

export const tourURL = (url) => {
    return getStateAwareUrl('/static/img/tour_images/' + url)
}

export const tourGuideForDashboard = () => {
    setTimeout(() => {
            introJs().setOptions({
                steps: [
                {
                    title: 'Welcome',
                    disableInteraction: true,
                    intro: '<a style="color: black">Hello👋</a></br></br><a style="color: black">Lets begin with a mini tour around the Morphle Dashboard</a>'
                },
                {
                    element: document.querySelector('.scans-forTour'),
                    title: 'All Scans',
                    intro: 'Clicking here will allow you to see all scans',
                    disableInteraction: true,
                },
                {
                    element: document.querySelector('.page-forTour'),
                    title: 'Scan Navigator',
                    disableInteraction: true,
                    intro: 'Here you can see all scan pages and navigate to it by clicking on it'
                },
                {
                    element: document.querySelector('.slide-entry-forTour'),
                    title: 'Scan',
                    disableInteraction: true,
                    intro: 'Here you can see all the Scans listed individualy and can be viewed by clicking on it'
                },
                {
                    element: document.querySelector('.star-forTour'),
                    title: 'Star a Scan',
                    disableInteraction: true,
                    intro: '<a style="color: black">click on the Star button on a scan to mark as important</a></br>'
                },
                {
                    element: document.querySelector('.upload-forTour'),
                    title: 'Upload',
                    disableInteraction: true,
                    intro: `<a style="color: black">Click on the upload button as shown below</a></br> <img src="${tourURL("upload.gif")}" style="display: block; margin-left: auto; margin-right: auto;"/>`
                },
                {
                    element: document.querySelector('.export-forTour'),
                    title: 'EXPORT SCAN',
                    disableInteraction: true,
                    intro: `<a style="color: black">Click on the export button to Queue scans for Export in <b>.tiff </b> or <b>.zip</b></a></br></br><img src="${tourURL("export.gif")}" style="display: block; margin-left: auto; margin-right: auto;"/>`
                },
                {
                    element: document.querySelector('.export-forTour'),
                    title: 'EXPORT SCAN',
                    disableInteraction: true,
                    intro: `<a style="color: black">We can <b> prioritize </b>export and <b> cancel </b> anytime before it starts</a></br><img src="${tourURL("queueexport.gif")}" style="display: block; margin-left: auto; margin-right: auto;"/>`
                },
                {
                    element: document.querySelector('.export_settings-forTour'),
                    title: 'EXPORT SCAN SETTINGS',
                    intro: 'For Additional Export Scan settings click here and edit settings',
                    disableInteraction: true,
                },
                {
                    element: document.querySelector('.tags-forTour'),
                    title: 'ADD TAGS',
                    intro: `<a style="color: black">Click here on the tags button you will able to give tags to scans.</a></br><img src="${tourURL("tags.gif")}" style="display: block; margin-left: auto; margin-right: auto;"/><a style="color: black">Tags can be used to<b> Mark, Search and Filter Scans</b></a></br>`,
                    disableInteraction: true,
                },
                {
                    element: document.querySelector('.slide-name-forTour'),
                    title: 'Scan Name',
                    intro: '<a style="color: black">This is the name of the scan auto-Generated or Read by the barcode.</br>User has the option to edit scan name before and after scanning</a></br>',
                    disableInteraction: true,
                },
                {
                    element: document.querySelector('.ant-table-selection-column'),
                    title: 'Select Scan',
                    tooltipClass: 'customTooltip',
                    disableInteraction: true,
                    intro: `<a style="color: black">Click on the checkbox for single/multiple scans to delete,upload,star and add Tags to multiple slides at once</a></br><img src="${tourURL("select_scan.gif")}" /></br><a style="color: black">And cancel when not needed</a>`,
                },
                {
                    element: document.querySelector('.slide-entry-forTour'),
                    title: 'Open Scan',
                    intro: 'Lets open Scan and Go through some features of our Morphle Slide Viewer',
                    position: 'bottom-middle-aligned'
                },
            ].filter(function (obj) {
                return obj.element !== null;}
            )
        }).setOptions(
            {
                exitOnOverlayClick: false
            }).oncomplete(() => {store.dispatch(stopWebsiteTour() && store.dispatch(startWebsiteTourForScan()))}).onexit(() => {store.dispatch(stopWebsiteTour())}).start();
    }, 100)
    return true
}



export const tourGuideForScan = () => {
    setTimeout(() => {              
            introJs().setOptions({
                steps: [
                {
                    title: 'Scan viewer',
                    intro: '<a style="color: black">Lets go through all the features</a>'
                    },
                    {
                    element: document.querySelector('.topBarBrightness-forTour'),
                    title: 'Scan Display Settings',
                    intro: `<a style="color: black">Use slider to change Brightness settings </a></br><img src="${tourURL("brightness.gif")}" style="display: block; margin-left: auto; margin-right: auto;"/>`
                },
                {
                    element: document.querySelector('.topBarContrast-forTour'),
                    title: 'Scan Display Settings',
                    intro: `<a style="color: black">Use slider to change Contrast settings </a></br><img src="${tourURL("contrast.gif")}" style="display: block; margin-left: auto; margin-right: auto;"/>`
                },
                {
                    element: document.querySelector('.Colours-forTour'),
                    title: 'Colour of annotations',
                    intro: `<a style="color: black">change colour of annotations </a></br><img src="${tourURL("colours.gif")}" style="display: block; margin-left: auto; margin-right: auto;"/>`
                },
                {
                    element: document.querySelector('.Line-forTour'),
                    title: 'Line',
                    intro: `<a style="color: black">Use this feature to draw a line from one point to another around the scan to highlight a observation</br><b>HOW TO USE?</b></br>Click on the button and select two points to where the line has to be drawn</br><b>NOTE:</b>do not hold on to your left click</a></br><img src="${tourURL("line.gif")}" style="display: block; margin-left: auto; margin-right: auto;"/>`
                },
                {
                    element: document.querySelector('.FreeLine-forTour'),
                    title: 'FreeLine',
                    intro: `<a style="color: black">Use this feature to a freeline around the scan to highlight a observation</br><b>NOTE:</b>Click on it and drag the mouse around to draw lines</a><img src="${tourURL("freeline.gif")}" style="display: block; margin-left: auto; margin-right: auto;"/>`
                },
                {
                    element: document.querySelector('.Circle-forTour'),
                    title: 'Circle',
                    intro: `<a style="color: black">Click on the button and select point to where the Circle has to be drawn</br><b>NOTE: </b>click once and let go of the leftclick then drag the mouse around to change size then click again</a></br><img src="${tourURL("circle.gif")}" style="display: block; margin-left: auto; margin-right: auto;"/>`
                },
                {
                    element: document.querySelector('.FreeHand-forTour'),
                    title: 'FreeHand',
                    intro: `<img src="${tourURL("freehand.gif")}" style="display: block; margin-left: auto; margin-right: auto;"/>`
                },
                {
                    element: document.querySelector('.Rectangle-forTour'),
                    title: 'Rectangle',
                    intro: `<img src="${tourURL("rectangle.gif")}" style="display: block; margin-left: auto; margin-right: auto;"/>`
                },
                {
                    element: document.querySelector('.Polygon-forTour'),
                    title: 'Polygon',
                    intro: `<img src="${tourURL("polygon.gif")}" style="display: block; margin-left: auto; margin-right: auto;"/>`
                },
                {
                    element: document.querySelector('.grid-forTour'),
                    title: 'Grid',
                    intro: '<a style="color: black">Grid Overlay can be enabled from here</a>'
                },
                {
                    element: document.querySelector('.screenshot-forTour'),
                    title: 'Screenshot',
                    intro: '<a style="color: black">Take screenshot of current view of Scan</a>'
                },
                {
                    element: document.querySelector('.ScanToPdf-forTour'),
                    title: 'PDF',
                    intro: '<a style="color: black"> Download the complete scan in a 1:1 ratio to the slide in PDF format</a>'
                },
                {
                    element: document.querySelector('.go-to-prev-forTour'),
                    title: 'Go to Prev Slide',
                    intro: '<a style="color: black"> Go to previous slide (ordered as per dashboard)</a>'
                },
                {
                    element: document.querySelector('.go-to-next-forTour'),
                    title: 'Go to Next Slide',
                    intro: '<a style="color: black"> Go to next slide (ordered as per dashboard)</a>'
                },
                {
                    element: document.querySelector('.ImageLoadProgress-forTour'),
                    title: 'Image Loading Progress',
                    intro: '<a style="color: black">Wait for Image Loading Progress icon to turn green to start viewing</a>'
                },
                {
                    element: document.querySelector('.scanslidename-forTour'),
                    title: 'Edit Slide Name',
                    intro: '<a style="color: black"> Edit slide name of slide you are currently viewing</a>'
                },
                {
                    element: document.querySelector('.share-slide-forTour'),
                    title: 'Share Slide Link',
                    intro: '<a style="color: black"> Share slide you are currently viewing</a>'
                },
                {
                    element: document.querySelector(".preview-controls-forTour"),
                    title: 'Preview Viewer',
                    intro: '<a style="color: black">Here you can view the preview of scan and visited area by clicking on <b>Show Seen Area</b></a>'
                },
                {
                    element: document.querySelector(".thumbnail-forTour"),
                    title: 'Thumbnail Viewer',
                    intro: '<a style="color: black">View Thumbnail from here</a>',
                },
                {
                    element: document.querySelector(".barcode-forTour"),
                    title: 'Barcode Viewer',
                    intro: '<a style="color: black">View Barcode </a>'
                 },
                {
                	element: document.querySelector(".zoomControl-forTour"),
                	title: 'Zoom Control',
                	intro: '<a style="color: black">Here you can see the zoom level of the scan </br> You can use the scroll wheel to Zoom In/Out or click here</a>'
                },
                {
                	element: document.querySelector(".LayersControl-forTour"),
                	title: 'Layers Control',
                	intro: '<a style="color: black">Layers Control allowes user to hide and view layers on the Scan</a>'
                },
                // {
                // 	element: document.getElementById("display_calibration"),
                // 	title: 'Annotations Viewer',
                // 	intro: '<a style="color: black">modify and view annotations </a>'
                // },
                // {
                // 	element: document.getElementById("configuration"),
                // 	title: 'Annotations Viewer',
                // 	intro: '<a style="color: black">modify and view annotations </a>'
                // }
            ].filter(function (obj) {
                return obj.element !== null;}
            )
        }).setOptions(
        {
            showBullets: false
        }).setOptions(
        {
            exitOnOverlayClick: false
          }).onexit(() => store.dispatch(stopWebsiteTourForScan())).start();
    }, 100)
}